import { jsx } from "react/jsx-runtime";
const CircleOutlineIcon = (props) => /* @__PURE__ */ jsx("svg", { ...props, viewBox: "0 0 32 32", children: /* @__PURE__ */ jsx(
  "circle",
  {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none"
  }
) });
export {
  CircleOutlineIcon
};
